<template>
  <div v-if="showInfoBanner">
    <div class="fixed inset-0 bg-black/50 z-[9998]"></div>
    <div
      class="fixed top-1/2 left-1/2 z-[9999] w-[420px] max-w-[90vw] -translate-x-1/2 -translate-y-1/2 rounded-xl bg-white p-6 text-center shadow-xl"
    >
      <h3 class="mb-3 text-lg font-semibold text-gray-900">
        {{ t('Desktop Recommended') }}
      </h3>

      <p class="mb-5 text-gray-700 leading-relaxed">
        {{
          t(
            'This website is designed for desktop use only and is not fully supported on mobile devices.'
          )
        }}
      </p>

      <button
        class="rounded-full bg-red-600 px-5 py-2 font-semibold text-white transition hover:opacity-90"
        @click="acceptInfoBanner"
      >
        {{ t('Continue') }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted  } from 'vue'
import { useState } from 'modules/auth/store/state'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'InfoBanner',
  setup() {
    const authState = useState()
    const { t } = useI18n()
    const showInfoBanner = ref(true)
    
    const acceptInfoBanner = () => {
      authState.setInfoBanner(true);
      showInfoBanner.value = false;
    }

    const checkInfoBanner = () => {
      if (authState.info_banner !== null) {
        showInfoBanner.value = false;
      }
    }

    onMounted(() => {
      checkInfoBanner()
    })

    return {
      t,
      showInfoBanner,
      acceptInfoBanner,
      checkInfoBanner,
    }
  },
})
</script>


<style scoped>


</style>